/**
 * Generic UI widgets & interactions (page-agnostic).
 *
 * Put here:
 * - Toggles, tabs, accordions, "read more", mobile filter sheet
 *
 * Avoid here:
 * - Nav-specific code (use `nav.js`)
 * - Third-party library setup (use `libs.js`)
 */
export function initUI() {
	// =========================
	// FILTER TOGGLE (mobile)
	// =========================
	const filterToggle = document.querySelector(".filter-toggle");
	const closeFilter = document.querySelector(".close-filter");
	const mobileFilter = document.querySelector(".mobile-filter-wrap");
	const cards = document.querySelectorAll('.card-border');

	// Use event delegation in case ez-toc-list is initialized after this script runs
	document.addEventListener('click', function (e) {
		const clickedLink = e.target.closest('.ez-toc-list li a.ez-toc-link');
		if (!clickedLink) return;

		const toc = clickedLink.closest('.ez-toc-list');
		if (toc) {
			// Remove active from all TOC links
			toc.querySelectorAll('li a.ez-toc-link').forEach(item => item.classList.remove('active'));

			// Add active to clicked link
			clickedLink.classList.add('active');
		}
	});


	$(".mobile-menu-nav .menu-item > a").wrap("<div class='title'></div>");
	$(".menu-item-has-children >.title").append("<div class='icon'></div>");

	$(".mobile-menu-nav .menu-item-has-children .title .icon").on("click", function () {
		$(this).parent().next().slideToggle();
		$(this).parent().toggleClass('is-active');
	});

	try {
		const cardHover = $('.card-option');
		try {

			if (cardHover !== null) {


				cardHover.on('mouseenter', function () {
					$('.card-option').removeClass('is-active');
					$(this).toggleClass('is-active');
				});
			}
		} catch (error) {

		}
	} catch (error) {

	}


	const resize = () => {
		cards.forEach(card => {
			const svg = card.querySelector('.border-svg');
			const rect = card.querySelector('.border-rect');

			const w = card.offsetWidth;
			const h = card.offsetHeight;

			svg.setAttribute('viewBox', `0 0 ${w} ${h}`);

			rect.setAttribute('x', 0.5);
			rect.setAttribute('y', 0.5);
			rect.setAttribute('width', w - 1);
			rect.setAttribute('height', h - 1);
		});
	};

	new ResizeObserver(resize).observe(document.body);
	resize();


	try {

		const bgContainer = $(".section-hover .bg-placeholder");
		$(".section-hover .item-bg").each(function () {
			$(this).on("mouseenter", function () {
				let srcImage = $(this).attr("data-src");
				bgContainer[0].style.setProperty("--bg-hover", `url(${srcImage})`);
				bgContainer.css("--bg-hover", `url(${srcImage})`);
			});
		});

		bgContainer.on("mouseenter", function () {
			$(this).addClass("active");
		});
		bgContainer.on("mouseleave", function () {
			$(this).removeClass("active");
		});

	} catch (error) {
		console.log(error);
	}

	document.querySelectorAll('.drop-menu .icon').forEach(icon => {
		icon.addEventListener('click', function (e) {
			e.stopPropagation();

			const current = this.closest('.drop-menu');
			const isActive = current.classList.contains('active');

			document.querySelectorAll('.drop-menu').forEach(item => {
				item.classList.remove('active');
			});

			if (!isActive) {
				current.classList.add('active');
			}
		});
	});



	$(".toggle-wrapper").each(function (index, element) {
		let $this = $(this);
		$this.addClass("toggle-inst-" + index);
		$(".toggle-inst-" + index + " .toggle-box .title").click(function () {
			if ($(this).parents('.toggle-box').hasClass("is-toggle")) {

				$(this).parents('.toggle-box').find(".article").slideUp();
				$(this).parents('.toggle-box').removeClass("is-toggle");
			} else {
				$(".toggle-box").find(".article").slideUp();
				$(".toggle-box").removeClass("is-toggle");
				$(this).parents('.toggle-box').find(".article").slideDown();
				$(this).parents('.toggle-box').addClass("is-toggle");
			}
		});
	});

	try {
		$('.toggle-wrap').each(function () {
			$(this).find('.toggle-item').first()
				.addClass('is-toggle')
				.find('.article').show();
		});
		$('.toggle-item .article').hide();

		// Restore open state for any item that already has is-toggle on load
		$('.toggle-item.is-toggle .article').show();

		// Function to handle the toggle logic with jQuery slideToggle
		function handleToggle($targetItem) {
			if (!$targetItem || $targetItem.length === 0) return;

			const isActive = $targetItem.hasClass('is-toggle');
			const $parent = $targetItem.parent();

			// Close all sibling toggle items smoothly
			$parent.find('.toggle-item').not($targetItem).each(function () {
				$(this).removeClass('is-toggle')
					.find('.article')
					.slideUp(300);
			});

			// Toggle current item
			if (isActive) {
				$targetItem.removeClass('is-toggle')
					.find('.article')
					.slideUp(300);
			} else {
				$targetItem.addClass('is-toggle')
					.find('.article')
					.slideDown(300);
			}
		}

		// Click event listener for toggle items
		$('.toggle-wrap').not('.about-core-values .toggle-wrap').on('click', '.toggle-item .title', function () {
			handleToggle($(this).closest('.toggle-item'));
		});


		// 3. .about-core-values — hover activate + autoplay
		(function () {
			const $section = $('.about-core-values');
			if (!$section.length) return;

			const AUTOPLAY_DELAY = 5000;
			let autoplayTimer = null;

			function activateItem($item) {
				const $items = $section.find('.toggle-item');
				const $parent = $item.parent();

				// Deactivate all others
				$items.not($item).each(function () {
					$(this).removeClass('is-toggle')
						.find('.article')
						.slideUp(300);
				});

				// Activate target
				$item.addClass('is-toggle')
					.find('.article')
					.slideDown(300);

				// Swap image
				const targetIndex = $item.data('index');
				if (targetIndex) {
					$section.find('.image-list .image-item-index').removeClass('is-active');
					$section.find(`.image-list .${targetIndex}`).addClass('is-active');
				}
			}

			function startAutoplay() {
				stopAutoplay();
				autoplayTimer = setInterval(function () {
					const $items = $section.find('.toggle-item');
					const $active = $items.filter('.is-toggle');
					let nextIndex = 0;
					if ($active.length) {
						const currentIndex = $items.index($active.first());
						nextIndex = (currentIndex + 1) % $items.length;
					}
					activateItem($items.eq(nextIndex));
				}, AUTOPLAY_DELAY);
			}

			function stopAutoplay() {
				if (autoplayTimer) {
					clearInterval(autoplayTimer);
					autoplayTimer = null;
				}
			}

			// Hover: activate on mouseenter, resume autoplay on mouseleave
			$section.on('mouseenter', '.toggle-item', function () {
				stopAutoplay();
				activateItem($(this));
			});

			$section.on('mouseleave', function () {
				startAutoplay();
			});

			// Init: activate first item and start autoplay
			const $firstItem = $section.find('.toggle-item').first();
			if ($firstItem.length) activateItem($firstItem);
			startAutoplay();
		}());

	} catch (error) {

	}




	if (filterToggle && mobileFilter) {
		filterToggle.addEventListener("click", () => {
			mobileFilter.classList.add("is-open");
		});
	}

	if (closeFilter && mobileFilter) {
		closeFilter.addEventListener("click", () => {
			mobileFilter.classList.remove("is-open");
		});
	}

	// =========================
	// SIDE NAV TOGGLE
	// =========================
	document.querySelectorAll(".side-nav-mobile .title-nav").forEach((el) => {
		el.addEventListener("click", function () {
			const sideNav = document.querySelector(".side-nav");
			if (!sideNav) return;

			const isHidden =
				sideNav.style.display === "none" ||
				getComputedStyle(sideNav).display === "none";

			sideNav.style.display = isHidden ? "block" : "none";
			this.parentElement.classList.toggle("is-active");
		});
	});

	// =========================
	// TABS INIT
	// =========================
	document.querySelectorAll("section").forEach((section) => {
		const items = section.querySelectorAll(".tab-item");
		if (!items.length) return; // SAFETY: Skip if no tab items exist

		items.forEach((el) => (el.style.display = "none"));

		const active = section.querySelector(".tab-item.active");

		if (active) {
			active.style.display = "block";
		} else {
			const firstItem = items[0];
			if (firstItem) {
				firstItem.style.display = "block";
				firstItem.classList.add("active");
			}

			const firstNav = section.querySelector(".tab-nav li:first-child");
			if (firstNav) {
				firstNav.classList.add("active");
				firstNav.parentElement
					?.querySelectorAll("li")
					.forEach((li) => {
						if (li !== firstNav) li.classList.remove("active");
					});
			}
		}
	});

	// =========================
	// READ MORE INIT
	// =========================
	const initReadMore = () => {
		document.querySelectorAll(".read-more-wrap").forEach((instance) => {
			const article = instance.querySelector(".article");
			const buttonReadMore = instance.querySelector(".btn-read-more");

			// SAFETY: If a tab has .read-more-wrap but is missing the article or buttonReadMore inside, skip it to prevent errors.
			if (!article || !buttonReadMore) return;

			// Skip if element is currently hidden
			if (article.offsetParent === null) return;

			const isMobile = window.innerWidth < 1200;
			const heightLimit = isMobile ? 300 : 400;

			// reset first
			article.style.height = "";
			article.style.overflow = "";
			buttonReadMore.classList.remove("hide");

			const fullHeight = article.scrollHeight;
			if (fullHeight <= heightLimit) {
				buttonReadMore.classList.add("hide");
				return;
			}

			if (!instance.classList.contains('is-expanded')) {
				article.style.height = heightLimit + "px";
				article.style.overflow = "hidden";
			}
		});
	};

	setTimeout(() => {
		initReadMore();
	}, 50);

	let isMobile = window.innerWidth < 1200;
	window.addEventListener("resize", () => {
		const newIsMobile = window.innerWidth < 1200;
		if (newIsMobile !== isMobile) {
			isMobile = newIsMobile;
			initReadMore();
		}
	});

	// =========================
	// READ MORE TOGGLE EVENT
	// =========================
	document.addEventListener("click", (e) => {
		const readMoreBtn = e.target.closest(".btn-read-more");
		if (readMoreBtn && !readMoreBtn.classList.contains("hide")) {
			e.preventDefault();

			const wrap = readMoreBtn.closest(".read-more-wrap");
			// SAFETY: Ensure the wrap exists
			if (!wrap) return;

			const article = wrap.querySelector(".article");
			// SAFETY: Ensure the article exists
			if (!article) return;

			wrap.classList.toggle("is-expanded");

			if (wrap.classList.contains("is-expanded")) {
				article.style.height = article.scrollHeight + "px";
			} else {
				const isMob = window.innerWidth < 1200;
				article.style.height = (isMob ? 300 : 1500) + "px";
			}
		}
	});

	// =========================
	// GLOBAL CLICK (TABS)
	// =========================
	document.addEventListener("click", (e) => {
		const link = e.target.closest(".tab-nav a");
		if (!link) return;

		e.preventDefault();

		const nav = link.closest(".tab-nav");
		const section = link.closest("section");

		if (!nav || !section) return;

		nav.querySelectorAll("li").forEach((li) =>
			li.classList.remove("active")
		);
		link.closest("li")?.classList.add("active");

		const tab = link.getAttribute("data-type");
		if (!tab) return; // SAFETY: Ensure data-type attribute exists

		const items = section.querySelectorAll(".tab-item");

		items.forEach((el) => {
			el.style.display = "none";
			el.classList.remove("active");
			el.style.opacity = 0;
		});

		const target = section.querySelector("#" + tab);
		if (target) {
			target.style.display = "block";
			target.classList.add("active");

			initReadMore();

			let opacity = 0;
			const fade = () => {
				opacity += 0.1;
				target.style.opacity = opacity;
				if (opacity < 1) requestAnimationFrame(fade);
			};
			fade();
		}
	});

	$(".sticky-nav  a").on("click", function (event) {
		let $this = $(this)
		event.preventDefault();
		if (this.hash !== "") {
			let offset =
				$("header").outerHeight() + $(".sticky-nav").outerHeight();
			var hash = this.hash;
			// If inside a modal, try to find the target inside the same modal first to avoid selecting cloned hidden elements
			let $context = $this.closest('.popup-modal, .fancybox__content, .modal-wrap, .fancybox__container');
			let $target = $context.length ? $context.find(hash) : $(hash);

			if ($target.length === 0) {
				$target = $(hash); // fallback
			}

			if ($target.length) {
				let $scrollContainer = $target.closest('.scroll-section-wrap, .modal-wrap, .fancybox__content');
				if ($scrollContainer.length > 0) {
					let targetTop = $scrollContainer.scrollTop() + $target.offset().top - $scrollContainer.offset().top;
					$scrollContainer.animate(
						{
							scrollTop: targetTop - 20,
						},
						800
					);
				} else {
					$("html, body").animate(
						{
							scrollTop: $target.offset().top - offset,
						},
						800,
						function () {
							// window.location.hash = hash;
						}
					);
				}
			} else {
				console.warn('Target element not found:', hash);
			}
		} // End if
	});

	// =========================
	// WRAP IFRAMES IN FIGURE (.fullcontent)
	// =========================
	const wrapIframesInFigure = () => {
		const iframes = document.querySelectorAll(".fullcontent iframe");
		iframes.forEach((iframe) => {
			// Condition: check if already inside a figure or detached
			if (iframe.closest("figure") || !iframe.parentNode) return;

			const figure = document.createElement("figure");
			iframe.parentNode.insertBefore(figure, iframe);
			figure.appendChild(iframe);
		});
	};

	wrapIframesInFigure();
}